export function isLocalDevHost(hostname = window.location.hostname) {
  const host = hostname.toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "::1" || host === "[::1]" || host.endsWith(".local");
}

export function isLocalDevFrontend() {
  if (typeof window === "undefined") return false;
  return isLocalDevHost(window.location.hostname);
}

export function isStagingPreviewHost(hostname = window.location.hostname) {
  return hostname.toLowerCase().endsWith(".pages.dev");
}

export function isStagingPreviewFrontend() {
  if (typeof window === "undefined") return false;
  return isStagingPreviewHost(window.location.hostname);
}
